import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ljubljana hasn't heard of plows --> snow driving yayz!",
  "description": "",
  "published": "2010-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/ljubljana-hasnt-heard-of-plows-snow-driving-yayz/swizec/1069"],
  "categories": "intrigues, life, Snow, Uncategorized, Weather",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`After tonight's midterm I simply couldn't resist driving around and about Ljubljana in this magnificent snowy weather we're having. It's very rare to get a chance to drive in conditions where everyone is nice and calm. Nobody honks at you, nobody tries to swerve around you and do stupid things, nobody is in a hurry. It's just fucking awesome!`}</p>
    <p>{`Not to mention the snow and the occasional drift around a corner! Orgasmic! Oh!`}</p>
    <p>{`Although winter services could be a little more vigilant, I got thrown all over the place driving through tracks others made. There was snow up to 20 centimeters deep someplaces! On main roads!!`}</p>
    <p>{`Anyway, had fun, was awesome, got stuck in the snow on the parking lot at home. That was a big lol, but a surprisingly large amount of people I don't know decided to be helpful and we got the car into a parking space in no time.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00156.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00156.jpg",
          "alt": "IMG00156",
          "title": "IMG00156"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00153.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00153.jpg",
          "alt": "IMG00153",
          "title": "IMG00153"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00152.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00152.jpg",
          "alt": "IMG00152",
          "title": "IMG00152"
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/87c0cdc9-629f-4974-91db-5b1a8a7e985f/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=87c0cdc9-629f-4974-91db-5b1a8a7e985f",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      